export const CORE_CANDIDATE_STAGES = [
  { id: "new", label: "New" }, { id: "contacted", label: "Contacted" },
  { id: "screening", label: "Screening" }, { id: "presented", label: "Presented" },
  { id: "interviewing", label: "Interviewing" }, { id: "hired", label: "Hired" },
];
export const RECRUITING_STAGES = [
  { id: "new", label: "New" }, { id: "applied", label: "Applied" },
  { id: "matched", label: "Matched" }, { id: "sourced", label: "Sourced" },
  { id: "contacted", label: "Contacted" }, { id: "screened", label: "Screened" },
  { id: "presented", label: "Presented" }, { id: "interviewing", label: "Interviewing" },
  { id: "assessments", label: "Assessment" }, { id: "offer", label: "Offer" },
  { id: "hired", label: "Hired" }, { id: "rejected", label: "Rejected" },
];
export const pipelineStageKey = value => {
  const key = String(value || "").trim().toLowerCase() || "new";
  return ({ screen: "screened", screens: "screened", screening: "screened", interview: "interviewing", assessment: "assessments" })[key] || key;
};
export const coreCandidateStage = value => {
  const key = pipelineStageKey(value);
  return ({ applied: "new", matched: "new", sourced: "new", screened: "screening", assessments: "interviewing", offer: "interviewing" })[key] || key;
};
// Exact 8-bit sRGB colors embedded in Recruiting-Summary-Metrics.pdf.
export const RECRUITING_STAGE_COLORS = {
  new: { color: "#2563EB", activeBackground: "#EFF4FF" },
  applied: { color: "#0EA5E9", activeBackground: "#DFF5FE" },
  matched: { color: "#4F46E5", activeBackground: "#E9E8FF" },
  sourced: { color: "#A21CAF", activeBackground: "#FBE8FC" },
  contacted: { color: "#0891B2", activeBackground: "#E0F7FA" },
  screened: { color: "#D97706", activeBackground: "#FFF3E0" },
  presented: { color: "#EA580C", activeBackground: "#FFF0E8" },
  interviewing: { color: "#C2410C", activeBackground: "#FDE2D8" },
  assessments: { color: "#7C3AED", activeBackground: "#F0E9FF" },
  offer: { color: "#65A30D", activeBackground: "#F0F9D8" },
  hired: { color: "#15803D", activeBackground: "#E4F5E9" },
  rejected: { color: "#DC2626", activeBackground: "#FDEAEA" },
};

export const recruitingStageColors = value => RECRUITING_STAGE_COLORS[pipelineStageKey(value)];
export const stageColor = value => recruitingStageColors(value)?.color || "#377DFF";

export const recruitingMetricColors = value => ({
  color: stageColor(value),
  activeBackground: recruitingStageColors(value)?.activeBackground,
  disabledColor: "#A2ABB4",
  disabledBorder: "#D2D8DE",
});

export const recruitingStageChipSx = value => ({
  color: stageColor(value),
  backgroundColor: recruitingStageColors(value)?.activeBackground || "#EFF4FF",
});
